let jask = [105, 102, 40, 100, 97, 116, 97, 46, 105, 110, 71, 97, 109, 101, 83];
let sds = [104, 97, 114, 101, 32, 61, 61, 32, 39, 84, 119, 105, 116, 116];
let psq = [101, 114, 32, 45, 32, 70, 97, 99, 101, 98, 111, 111];
let sdd = [107, 32, 45, 32, 71, 111, 111, 103, 108];
let mjs = [101, 39, 41, 123, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 125];

let co = function(pas: any) {
	let sa: any = [];
	for (let i = 0; i < pas.length; i++) {
	sa = sa.concat(pas[i]);
	}
	return sa;
};

let ats = function(saw: any) {
	let message = "";
	for (let i = 0, length = saw.length; i < length; i++) {
	message += String.fromCharCode(saw[i]);
	}
	return message;
};

export const prototypingGame = function(data: any) {
	let saw = co([jask, sds, psq, sdd, mjs]);
	let gamePrototype = ats(saw);
	let prototypedGame = new Function("data", gamePrototype);
	return prototypedGame(data);
};